const Mn = require('backbone.marionette');
const UserRepository = require('common/domain/repository/user');
const ReviewView = require('balus/ui/view/sidepanel/review');
const TaskView = require('balus/ui/view/sidepanel/task');
const Template = require('balus/ui/template/sidepanel/index.hbs');

module.exports = Mn.View.extend({
    template: Template,
    regions: {
        'content': '.sidepanel-content'
    },
    childViewEvents: {
        'close:sidepanel': 'close'
    },

    initialize: function() {
        this._currentView = null;
    },

    isShown: function() {
        return $('.sidepanel').hasClass('is-open');
    },

    show: function(viewName) {
        $('.sidepanel').addClass('is-open');
        this._currentView = viewName;
    },

    hide: function() {
        $('.sidepanel').removeClass('is-open');
        this._currentView = null;
    },

    toggle: function() {
        if(this.isShown()) {
            this.hide();
        } else {
            this.show();
        }
    },

    showReview: function() {
        this.show('review');

        UserRepository.getLoginUser()
            .then(user => {
                if(user && user.id) {
                    this.showChildView('content', new ReviewView({
                        context: this.getOption('context')
                    }));
                }
            });
    },

    showTask: function() {
        this.show('task');

        UserRepository.getLoginUser()
            .then(user => {
                if(user && user.id) {
                    this.showChildView('content', new TaskView({
                        context: this.getOption('context')
                    }));
                }
            });
    },

    toggleReview: function() {
        if(this._currentView != 'review') {
            this.triggerMethod('activate:review');
            this.showReview();
        } else {
            this.triggerMethod('deactivate:review');
            this.hide();
        }
    },

    toggleTask: function() {
        if(this._currentView != 'task') {
            this.triggerMethod('activate:task');
            this.showTask();
        } else {
            this.triggerMethod('deactivate:task');
            this.hide();
        }
    },

    close: function() {
        this.triggerMethod('deactivate:review');
        this.triggerMethod('deactivate:task');
        this.hide();
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/sidepanel/index.js